import { useCallback, useMemo, useState } from "react";
import HeaderView from "../../../financial/components/HeaderView";
import Table from "../../../financial/components/Table";
import PaginationView from "../../../financial/components/PaginationView";
import CardWithHeaderTemplate from "../../../components/cardWithHeaderTemplate";

const Jobs = ({ftm_id, refreshKey = null}) => {
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [totalJobs, setTotalJobs] = useState(0);
    const [filters, setFilters] = useState({
        dateRange: null,
        selectedFtm: null
    });

    const handlePageChange = useCallback((newPage) => {
        setPage(newPage);
    }, []);

    const handleSetDateFilter = useCallback((dateRange) => {
        setFilters((prev) => ({ ...prev, dateRange }));
        setPage(1); // reset pagination
    }, []);

    const handleSetSelectedFtm = useCallback((ftm) => {
        setFilters((prev) => ({ ...prev, selectedFtm: ftm }));
        setPage(1);
    }, []);

    const header = useMemo(() => (
        <HeaderView
            selectedFtm={{value: ftm_id}}
            selectedDateRange={filters.dateRange}
            totalJobs={totalJobs}
            setSelectedFtm={handleSetSelectedFtm}
            setDateFilter={handleSetDateFilter}
            type="valuation"
        />
    ), [ftm_id, filters.dateRange, totalJobs, handleSetSelectedFtm, handleSetDateFilter]);

    const body = useMemo(() => (
        <Table
            selectedFtm={{value: ftm_id}}
            dataFilter={filters.dateRange}
            page={page}
            setTotalPages={setTotalPages}
            setTotalJobs={setTotalJobs}
            ftm_payment_filter={"unpaid"}
            refreshKey={refreshKey}
        />
    ), [filters.dateRange, ftm_id, page, refreshKey]);

    const footer = useMemo(() => (
        <PaginationView
            totalPages={totalPages}
            page={page}
            onPageChange={handlePageChange}
        />
    ), [totalPages, page, handlePageChange]);

    return (
        <CardWithHeaderTemplate
            header={header}
            body={body}
            footer={footer}
        />
    )
};

export default Jobs;